import {
  fromJS
} from 'immutable';

import {
  LOGIN, CITY_STATE, STATE, CLUSTER,
  AUDIO, ADMIN_LOGIN,
  ADMINS_DATA, KYC_DETAILS
} from '../action/user_action_types';

const INITIAL_STTATE = fromJS({
  userInfo: '',
  cityState: [],
  stateList: [],
  nearestLocation: [],
  audio: [], kycDetails: null,
  adminsData: [],
  clusterList: []
})

export default function (state = INITIAL_STTATE, action) {
  console.log(action);
  switch (action.type) {
    case LOGIN: {
      return fromJS({
        userInfo: action.payload
      })
    }
    case CITY_STATE: {
      return fromJS({
        cityState: action.payload.cityState
      })
    }
    case ADMIN_LOGIN: {
      const errorMessage = action.payload.errorMessage;
      return state.set('errorMessage', fromJS(errorMessage));
    }
    case STATE: {
      console.log(action);
      return fromJS({
        stateList: action.payload.stateList
      })
    }
    case AUDIO: {
      return fromJS({
        audio: action.payload.audio
      })
    }

    case ADMINS_DATA: {
      return state.set('adminsData', action.payload);
    }

    case KYC_DETAILS: {
      return state.set('kycDetails', action.payload);
    }

    case CLUSTER: {
      return fromJS({
        clusterList: action.payload.clusterList
      })
    }

  }
  return state;
}


// WEBPACK FOOTER //
// ./web/reducer/user_reducer.js